import axiosInstance from '../../axios-config';

const personalContactsApi = '/api/patients/{0}/contacts';
const personalContactAuthorizedAccessApi = '/api/patients/{0}/contacts/{1}?authorized={2}';
const personalContactUnlockAccountApi = '/api/patients/{0}/contacts/{1}/UnlockAccount';
const personalContactPasswordResetApi = '/api/patients/{0}/contacts/{1}/ResetPassword';

export const getPersonalContacts = (patientId) => (
  axiosInstance.get(personalContactsApi.replace('{0}', patientId))
);

export const resetContactPassword = (contact) => (
  axiosInstance.post(
    personalContactPasswordResetApi
      .replace('{0}', contact.patientId)
      .replace('{1}', contact.contactId)
  )
);

export const putPersonalContact = (contact) => (
  axiosInstance.put(
    personalContactsApi.replace('{0}', contact.patientId),
    contact,
    { headers: { 'Content-Type': 'application/json' } }
  )
);

export const postEnablePatientContactAccess = (contact, enableAccess) => (
  axiosInstance.post(
    personalContactAuthorizedAccessApi.replace('{0}', contact.patientId)
      .replace('{1}', contact.contactId)
      .replace('{2}', enableAccess)
  )
);

export const postUnlockPatientContactUserAccount = (contact) => (
  axiosInstance.post(
    personalContactUnlockAccountApi.replace('{0}', contact.patientId)
      .replace('{1}', contact.contactId)
  )
);